import { el } from 'redom';

import { BehaviorSubject } from 'rxjs';
import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import 'vanilla-colorful';

import OutsideClickEventRegistration from 'lib/outside-click-event-registration';
import VariablesDisplayControl from 'root/startup-view/campaigns/right-panel/editor-panel/editor/variables-display-control';

import PrefixedInput from './input';

import './index.scss';

const variables = [{
  path: 'p',
  description: 'Primary color'
}, {
  path: 's',
  description: 'Secondary color'
}, {
  path: 't',
  description: 'Tertiary color'
}, {
  path: 'b',
  description: 'Primary background color'
}, {
  path: 'sb',
  description: 'Secondary background color'
}, {
  path: 'tt',
  description: 'Text color'
}];

class HelptapColorPicker {

  constructor(configuration) {

    this.outsideEventRegistration = null;
    this.position = configuration.position || 'top';
    this.color$ = new BehaviorSubject(configuration.color || '');
    this.onChange = configuration.onChange;
    this.onClose = configuration.onClose;
    this.autoPosition = configuration.autoPosition === true;
    this.pickerContainer = el('.color-picker-container', [
      this.picker = el('hex-color-picker', {
        color: configuration.color || '#ff0000',
      })
    ]);
    this.prefixedInput = new PrefixedInput({
      value: configuration.color || '#ff0000',
      onChange: (newColor) => this.color$.next(newColor)
    });
    this.picker.addEventListener('color-changed', (event) => {
      const newColor = event.detail.value;
      this.color$.next(newColor);
    });
    this.color$.subscribe((newColor) => {

      const color = PrefixedInput.tryConvertToHexCode(newColor);

      this.picker.color = color;
      this.prefixedInput.setValue(color);
      this.onChange(color);

    });
    this.el = el('.helptap-color-picker-main', {
      class: 'editor-tool-container'
    }, [
      this.pickerContainer,
      el('.helptap-color-picker-input-section', {}, [
        this.prefixedInput,
        new VariablesDisplayControl({
          title: 'CSS color variables available in color pickers',
          variables
        })
      ])
    ]);

  }

  onmount() {

    if (typeof this.onClose === 'function') {
      this.outsideEventRegistration = new OutsideClickEventRegistration(this.el, this.onClose);
    }

    this.focus();

    if (this.autoPosition === false) {
      return;
    }

    const element = this.el;
    const anchorElement = this.el.parentNode;
    const viewportElement = void 0;
    const verticalOffset = 45;
    const horizontalOffset = 0;
    const startSide = this.position;
    const placeOnCenter = true;
    const positionableSides = void 0;

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  onunmount() {

    if (this.outsideEventRegistration !== null) {
      this.outsideEventRegistration.cancel();
    }

  }

  focus() {

    this.prefixedInput.focus();

  }

}

export default HelptapColorPicker;